<app-solid-label 
    width="140" 
    [background]="backgroundColor" 
    [content]="status | toSpanish : 'FEMALE' | capitalizeFirstLetters ">
</app-solid-label>